// NOTE: From Microsoft learn: https://learn.microsoft.com/ru-ru/azure/communication-services/concepts/email/email-attachment-allowed-mime-types

const mimeTypes = {
    "video/3gpp": ".3gp",
    "video/3gpp2": ".3g2",
    "application/x-7z-compressed": ".7z",
    "audio/aac": ".Aac",
    "video/x-msvideo": ".Avi",
    "image/bmp": "BMP",
    "text/csv": ".csv",
    "application/msword": ".doc",
    "application/vnd.ms-word.document.macroEnabled.12": ".docm",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "DOCX",
    "application/vnd.ms-fontobject": ".Eot",
    "application/epub+zip": ".Epub",
    "image/gif": ".gif",
    "application/gzip": ".gz",
    "image/vnd.microsoft.icon": "ICO",
    "text/calendar": ".ics",
    "image/jpeg": ".jpg, .jpeg",
    "application/json": "json.",
    "audio/midi": ".mid, .midi",
    "audio/mpeg": ".mp3",
    "video/mp4": "MP4",
    "video/mpeg": ".Mpeg",
    "audio/ogg": ".Oga",
    "video/ogg": ".Ogv",
    "application/ogg": ".Ogx",
    "application/onenote": "указанным.",
    "audio/opus": ".Opus",
    "font/otf": ".Otf",
    "application/pdf": "PDF",
    "image/png": "PNG",
    "application/vnd.ms-powerpoint.slideshow.macroEnabled.12": "PPSM",
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow": "PPSX",
    "application/vnd.ms-powerpoint": ".ppt",
    "application/vnd.ms-powerpoint.presentation.macroEnabled.12": ".pptm",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": "PPTX",
    "application/vnd.ms-publisher": ".pub",
    "application/x-rar-compressed": ".rar",
    "application/vnd.ms-outlook": ".rpmsg",
    "application/rtf": ".rtf",
    "image/svg+xml": ".svg",
    "application/x-tar": ".Смолы",
    "image/tiff": "TIF, TIFF",
    "font/ttf": ".Ttf",
    "text/plain": ".txt",
    "application/vnd.visio": ".vsd",
    "audio/wav": ".Wav",
    "audio/webm": ".Weba",
    "video/webm": ".Webm",
    "image/webp": ".webp",
    "audio/x-ms-wma": ".wma",
    "video/x-ms-wmv": ".wmv",
    "font/woff": ".woff",
    "font/woff2": ".woff2",
    "application/vnd.ms-excel": "XLS.",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.12": ".xlsb",
    "application/vnd.ms-excel.sheet.macroEnabled.12": ".xlsm",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "XLSX",
    "application/xml, text/xml": "XML",
    "application/zip": ".zip"
};

export { mimeTypes };
